import {Route, Routes} from "react-router-dom";
import {RouteHelper} from "../route/RouteHelper";
import "./ContainerStyleSheet.scss"
import Header from "../component/Header/Header";
import Profile from "../pages/profile/Profile";
import ReleaseDocuments from "../pages/releaseDocuments/ReleaseDocuments";
import Dashboard from "../pages/dashboard/Dashboard";
import React from 'react';
import ManagersList from "../pages/managersList/ManagersList";
import {ManagerDetail} from "../pages/managerDetail/ManagerDetail";
import {ManagerAccessLevelList} from "../pages/managerAccessLevelList/ManagerAccessLevelList";
import MagazineList from "../pages/magazine/MagazineList";
import ManagerAccessLevelDetails from "../pages/managerAccessLevelDetails/ManagerAccessLevelDetails";
import MagazineDetails from "../pages/magazine/magazineDetails/MagazineDetails";
import MagazineCategory from "../pages/magazineCategory/MagazineCategory";
import FileManager2 from "../pages/fileManager2/FileManager2";
import TagsList from "../pages/tagList/TagsList";
import MagazineWriters from "../pages/magazineWriters/MagazineWriters";
import MagazineWriterDetail from "../pages/magazineWriters/MagazineWriterDetail";
import NotFound from "../pages/notFound/NotFound";
import NotAccess from "../pages/notAccess/NotAccess";
import {FileManagerTypes} from "../component/fileManager/FileManager";
import PaymentGatewaysList from "../pages/paymentGatewaysList/PaymentGatewaysList";
import PaymentGatewayInformation from "../component/paymentGateway/paymentGatewayInformation/PaymentGatewayInformation";
import {TransactionsList} from "../pages/transactions/TransactionsList";
import UsersList from "../pages/usersList/UsersList";
import UserInformation from "../pages/userInfromation/UserInformation";
import UsersStatistics from "../pages/userInfromation/UsersStatistics";
import {TransactionDetail} from "../pages/transactions/TransactionDetail";
import ResidencesList from "../pages/residences/ResidencesList";
import ResidenceDetail from "../pages/residences/detail/ResidenceDetail";
import ResidencesManager from "../pages/residencesManager/ResidencesManager";
import ResidenceManagerInfo from "../pages/residencesManager/residenceManagerInfo/ResidenceManagerInfo";
import PeriodList from "../pages/periodList/PeriodList";
import PeriodDetails from "../pages/periodList/periodDetails/PeriodDetails";
import HabitationMonitoring from "../pages/habitationMonitoring/HabitationMonitoring";
import MawakibManagerList from "../pages/mawakibManager/MawakibManagerList";
import MawakibDetails from "../pages/mawakibManager/detail/MawakibDetails";
import TourismList from "../pages/tourism/TourismList";
import TourismCategory from "../pages/tourism/tourismCategory/TourismCategory";
import TourismReports from "../pages/tourism/TourismReports";
import TourismPlaceDetail from "../pages/tourism/detail/TourismPlaceDetail";
import {css} from "@emotion/css";
import VowList from "../pages/vow/VowList";
import VowPayments from "../pages/vow/VowPayments";
import VowDetail from "../pages/vow/detail/VowDetail";
import OccasionalBanner from "../pages/occasionalBanner/OccasionalBanner";
import OccasionalBannerDetails from "../pages/occasionalBanner/occasionalBannerDetails/OccasionalBannerDetails";
import {HabitationSettings} from "../pages/periodList/periodDetails/HabitationSettings";
import LanguageSetting from "../pages/languageSetting/LanguageSetting";
import AppVersionDetail from "../pages/appVersion/AppVersionDetail";
import AppVersionList from "../pages/appVersionList/AppVersionList";
import EtekafManagerList from "../pages/etekafManager/EtekafManagerList";
import EtekafDetail from "../pages/etekafManager/etekafDetail/EtekafDetail";
import MawakibServiceList from "../pages/mawakibServiceList/MawakibServiceList";
import MawakibServiceDetails from "../pages/mawakibServiceDetails/MawakibServiceDetails";
import MawkibRegistrationLicense from "../pages/mawkibRegistrationLicense/MawkibRegistrationLicense";
import MawkibLicenseDetails from "../pages/MawkibLicenseDetails/MawkibLicenseDetails";
import MawakibRegistrationLocation from "../pages/mawakibRegistrationLocation/MawakibRegistrationLocation";
import MawakibLocationDetails from "../pages/mawakibLocationDetails/MawakibLocationDetails";
import Products from "../pages/products/Products";
import ProductDetails from "../pages/products/productDetails/ProductDetails";
import ProductVariant from "../pages/productVariant/ProductVariant";
import ProductVariantDetails from "../pages/productVariant/productVariantDetails/ProductVariantDetails";
import MemorialNotes from "../pages/memorialNote/MemorialNotes";
import UsersAvatar from "../pages/usersAvatar/UsersAvatar";
import PredefinedAvatarDetails from "../pages/usersAvatar/predefinedAvatarDetails/PredefinedAvatarDetails";
import MemorialNoteDetails from "../pages/memorialNote/memorialNoteDetails/MemorialNoteDetails";
import WorkAndBusiness from "../pages/workAndBusiness/WorkAndBusiness";
import Campaigns from "../pages/campaigns/Campaigns";
import CampaignDetails from "../pages/campaigns/campaignDetails/CampaignDetails";
import GamePeriod from "../pages/gamePeriod/GamePeriod";
import GamePeriodDetails from "../pages/gamePeriodDetails/GamePeriodDetails";
import Games from "../pages/games/Games";
import GameDetails from "../pages/gameDetails/GameDetails";
import GameStageDetails from "../pages/gameStageDetails/GameStageDetails";
import GameRegistrantInformation from "../pages/gameRegistrantInformation/GameRegistrantInformation";
import GameTeamDetails from "../pages/gameTeamDetails/GameTeamDetails";

const Container = () => {

    return (
        <section
            className={"basePageContainer"} id={"basePageContainerId"}>
            <div className={"baseHeaderContainer"}>
                <Header/>
            </div>

            <section className={`basePageContentContainer`}>
                <Routes>
                    <Route path={RouteHelper.Profile.url} element={<Profile/>}/>

                    <Route path={RouteHelper.ReleaseDocuments.url} element={<ReleaseDocuments/>}/>

                    <Route path={RouteHelper.ManagersList.url} element={<ManagersList/>}/>
                    <Route path={RouteHelper.ManagersDetail.url} element={<ManagerDetail/>}/>
                    <Route path={RouteHelper.ManagersAccess.url} element={<ManagerAccessLevelList/>}/>
                    <Route path={RouteHelper.ManagersAccessDetail.url} element={<ManagerAccessLevelDetails/>}/>


                    <Route path={RouteHelper.Dashboard.url} element={<Dashboard/>}/>

                    <Route path={RouteHelper.MagazineList.url} element={<MagazineList/>}/>
                    <Route path={RouteHelper.MagazineCategory.url} element={<MagazineCategory/>}/>
                    <Route path={RouteHelper.TagList.url} element={<TagsList/>}/>

                    <Route path={RouteHelper.FileManager.url}
                           element={
                               <FileManager2
                                   buckets={[
                                       FileManagerTypes.POST_THUMBNAILS,
                                       FileManagerTypes.POST_IMAGES,
                                       FileManagerTypes.VIDEO,
                                       FileManagerTypes.AUDIO,
                                   ]}
                               />}/>

                    <Route path={RouteHelper.MagazineDetail.url} element={<MagazineDetails/>}/>
                    <Route path={RouteHelper.MagazineWriters.url} element={<MagazineWriters/>}/>
                    <Route path={RouteHelper.MagazineWriterDetail.url} element={<MagazineWriterDetail/>}/>

                    <Route path={RouteHelper.PaymentGatewaysList.url} element={<PaymentGatewaysList/>}/>
                    <Route path={RouteHelper.PaymentGatewaysInformation.url} element={<PaymentGatewayInformation/>}/>

                    <Route path={RouteHelper.MemorialNotes.url} element={<MemorialNotes/>}/>
                    <Route path={RouteHelper.MemorialNoteDetails.url} element={<MemorialNoteDetails/>}/>

                    <Route path={RouteHelper.TransactionsList.url} element={<TransactionsList/>}/>
                    <Route path={RouteHelper.TransactionDetail.url} element={<TransactionDetail/>}/>

                    <Route path={RouteHelper.UsersList.url} element={<UsersList/>}/>
                    <Route path={RouteHelper.UserInformation.url} element={<UserInformation/>}/>
                    <Route path={RouteHelper.UsersStatistics.url} element={<UsersStatistics/>}/>
                    <Route path={RouteHelper.UsersAvatar.url} element={<UsersAvatar/>}/>
                    <Route path={RouteHelper.PredefinedAvatarDetails.url} element={<PredefinedAvatarDetails/>}/>
                    <Route path={RouteHelper.UsersFileManager.url}
                           element={
                               <FileManager2
                                   buckets={[
                                       FileManagerTypes.PREDEFINED_AVATAR,
                                   ]}
                               />}/>

                    <Route path={RouteHelper.Residences.url} element={<ResidencesList/>}/>
                    <Route path={RouteHelper.ResidenceDetail.url} element={<ResidenceDetail/>}/>

                    <Route path={RouteHelper.ResidencesManager.url} element={<ResidencesManager/>}/>
                    <Route path={RouteHelper.ResidencesManagerInfo.url} element={<ResidenceManagerInfo/>}/>

                    <Route path={RouteHelper.PeriodList.url} element={<PeriodList/>}/>
                    <Route path={RouteHelper.PeriodDetails.url} element={<PeriodDetails/>}/>

                    <Route path={RouteHelper.HabitationReports.url} element={<HabitationMonitoring/>}/>


                    <Route path={RouteHelper.MawakibManagerList.url} element={<MawakibManagerList/>}/>
                    <Route path={RouteHelper.MawakibDetails.url} element={<MawakibDetails/>}/>
                    <Route path={RouteHelper.MawakibServiceList.url} element={<MawakibServiceList/>}/>
                    <Route path={RouteHelper.MawakibServiceDetails.url} element={<MawakibServiceDetails/>}/>
                    <Route path={RouteHelper.MawkibRegistrationLicense.url} element={<MawkibRegistrationLicense/>}/>
                    <Route path={RouteHelper.MawakibLicenseDetails.url} element={<MawkibLicenseDetails/>}/>
                    <Route path={RouteHelper.MawakibRegistrationLocation.url} element={<MawakibRegistrationLocation/>}/>
                    <Route path={RouteHelper.MawakibLocationDetails.url} element={<MawakibLocationDetails/>}/>

                    <Route path={RouteHelper.Products.url} element={<Products/>}/>
                    <Route path={RouteHelper.ProductDetails.url} element={<ProductDetails/>}/>
                    <Route path={RouteHelper.ProductVariant.url} element={<ProductVariant/>}/>
                    <Route path={RouteHelper.ProductVariantDetails.url} element={<ProductVariantDetails/>}/>


                    <Route path={RouteHelper.TourismPlaceList.url} element={<TourismList/>}/>
                    <Route path={RouteHelper.TourismPlaceDetail.url} element={<TourismPlaceDetail/>}/>
                    <Route path={RouteHelper.TourismCategory.url} element={<TourismCategory/>}/>
                    <Route path={RouteHelper.TourismReport.url} element={<TourismReports/>}/>
                    <Route path={RouteHelper.Campaigns.url} element={<Campaigns/>}/>
                    <Route path={RouteHelper.CampaignDetails.url} element={<CampaignDetails/>}/>
                    <Route path={RouteHelper.WorkAndBusiness.url} element={<WorkAndBusiness/>}/>

                    <Route path={RouteHelper.VowList.url} element={<VowList/>}/>
                    <Route path={RouteHelper.VowDetail.url} element={<VowDetail/>}/>
                    <Route path={RouteHelper.VowPayments.url} element={<VowPayments/>}/>

                    <Route path={RouteHelper.OccasionalBanner.url} element={<OccasionalBanner/>}/>
                    <Route path={RouteHelper.OccasionalBannerDetail.url} element={<OccasionalBannerDetails/>}/>

                    <Route path={RouteHelper.AppVersionList.url} element={<AppVersionList/>}/>
                    <Route path={RouteHelper.AppVersionDetail.url} element={<AppVersionDetail/>}/>

                    <Route path={RouteHelper.HabitationSettings.url} element={<HabitationSettings/>}/>
                    <Route path={RouteHelper.LanguageSetting.url} element={<LanguageSetting/>}/>

                    <Route path={RouteHelper.EtekafManagerList.url} element={<EtekafManagerList/>}/>
                    <Route path={RouteHelper.EtekafDetails.url} element={<EtekafDetail/>}/>


                    <Route path={RouteHelper.GamePeriod.url} element={<GamePeriod/>}/>
                    <Route path={RouteHelper.GamePeriodDetails.url} element={<GamePeriodDetails/>}/>
                    <Route path={RouteHelper.Games.url} element={<Games/>}/>
                    <Route path={RouteHelper.GameDetails.url} element={<GameDetails/>}/>
                    <Route path={RouteHelper.GameStageDetails.url} element={<GameStageDetails/>}/>
                    <Route path={RouteHelper.GameRegistrantInformation.url} element={<GameRegistrantInformation/>}/>
                    <Route path={RouteHelper.GameTeamDetails.url} element={<GameTeamDetails/>}/>

                    <Route path="/403" element={<NotAccess/>}/>
                    <Route path={'/'} element={<Dashboard/>}/>
                    <Route path="/*" element={<NotFound/>}/>
                </Routes>
            </section>
            {/*<section className={css`
                width: 100%;
                padding: .5rem;
                display: flex;
                align-items: center;
                justify-content: center;
            `}>
                <span>test</span>
            </section>*/}

        </section>
    )
}
export default Container